import React from 'react';

import type { IconProps } from '@/core/components/Icons/Icons';

const PlayCircle: React.FC<IconProps> = ({ className }) => (
  <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.66797 8.33333L10.0013 11.6667L13.3346 8.33333M3.33464 2.5H16.668C17.11 2.5 17.5339 2.67559 17.8465 2.98816C18.159 3.30072 18.3346 3.72464 18.3346 4.16667V9.16667C18.3346 11.3768 17.4567 13.4964 15.8939 15.0592C14.3311 16.622 12.2114 17.5 10.0013 17.5C8.90695 17.5 7.82332 17.2845 6.81227 16.8657C5.80123 16.4469 4.88257 15.833 4.10875 15.0592C2.54594 13.4964 1.66797 11.3768 1.66797 9.16667V4.16667C1.66797 3.72464 1.84356 3.30072 2.15612 2.98816C2.46868 2.67559 2.89261 2.5 3.33464 2.5Z"
      stroke="#4B4DED"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PlayCircle;
